/**
 * Standalone waiting UI for /imperva.
 * This URL is loaded in a sandboxed iframe (allow-scripts, no allow-same-origin).
 * It must not touch sessionStorage, localStorage, cookies, parent/top, or boot Angular.
 */

const IMPERVA_STYLES = `
.imperva-waiting-root {
  display: block;
  font-family: 'Saudia-Sans', Arial, Helvetica, sans-serif;
}
.imperva-waiting-root,
.imperva-waiting-root * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.imperva-waiting-root .loading-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
.imperva-waiting-root .loading-card {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid rgba(0, 0, 0, .1);
  box-shadow: 0 20px 40px #00000008, 0 20px 40px #00000005, 0 15px 20px #00000005, 0 8px 10px #00000005, 0 3px 6px #00000003, 0 1px 2px #00000003;
  border-radius: 4px;
  padding: 60px 40px 30px;
  text-align: center;
}
.imperva-waiting-root .brand {
  margin-bottom: 32px;
}
.imperva-waiting-root .brand img {
  width: 150px;
}
.imperva-waiting-root h1 {
  font-size: 24px;
  margin-bottom: 16px;
}
.imperva-waiting-root p {
  font-size: 16px;
  line-height: 26px;
  font-weight: normal;
  margin-bottom: 16px;
  color: #000000b3;
}
`;

const IMPERVA_MARKUP = `
<main class="loading-page">
  <div class="loading-card">
    <div class="brand">
      <img src="assets/images/Saudia-logo(NEW).svg" alt="Saudia Business">
    </div>
    <h1>Please stand by</h1>
    <p>
      We're getting everything ready for you. The page is loading, and
      you'll be on your way in just a few moments.
    </p>
    <p class="loading-card__thanks">
      Thanks for your patience!
    </p>
  </div>
</main>
`;

export function isImpervaWaitingPath(): boolean {
  try {
    const path = trimTrailingSlash(
      (globalThis.location?.pathname || '').split('?')[0].split('#')[0]
    );
    return path === '/imperva' || path.endsWith('/imperva');
  } catch {
    return false;
  }
}

function trimTrailingSlash(path: string): string {
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
}

export function tryRenderImpervaWaitingPage(): boolean {
  if (!isImpervaWaitingPath()) {
    return false;
  }

  try {
    renderImpervaWaitingPage();
  } catch {
    // Keep the SPA from booting even if painting fails.
  }

  return true;
}

function renderImpervaWaitingPage(): void {
  try {
    document.title = 'Waiting Page';
  } catch {
    // Title is optional in a sandboxed document.
  }

  const style = document.createElement('style');
  style.textContent = IMPERVA_STYLES;
  document.head.appendChild(style);

  const host = document.createElement('div');
  host.className = 'imperva-waiting-root';
  host.innerHTML = IMPERVA_MARKUP;

  const root = document.querySelector('app-root');
  if (root) {
    root.replaceWith(host);
  } else {
    document.body.appendChild(host);
  }
}
